import React from "react";
import AboutHero from "../components/about/AboutHero";
import WhoWeAre from "../components/about/WhoWeAre";
import StoryScroll from "../components/about/StoryScroll";
import MissionVision from "../components/about/MissionVision";
import ValuesList from "../components/about/ValuesList";
import ImpactMetrics from "../components/about/ImpactMetrics";
import Philosophy from "../components/about/Philosophy";
import AboutCta from "../components/about/AboutCta";

/**
 * The about page, as one continuous story in eight movements.
 *
 * This file is composition only. Every section owns its own layout and its
 * own motion, and all of the copy lives in `src/data/about.js` — so the order
 * of the story can be changed here without touching a single word or a single
 * animation.
 *
 * The order is the argument: who we are, how we got here, what we are for,
 * what we believe, what it adds up to, and what to do next.
 *
 * The sections alternate light and dark deliberately. Read top to bottom the
 * page goes dark → cream → warm → dark → cream → dark → dark → dark, which is
 * what gives it rhythm and lets the closing sections run together as one long
 * finish rather than reading as more bands.
 *
 * A <div> rather than a <main>: App.js already puts the routes inside one,
 * and the page sits under a transparent header on this route, so the hero
 * supplies its own top clearance.
 */

function AboutUs() {
  return (
    <div className="bg-[#FAF8F2] text-[#1E1B16]">
      <AboutHero />
      <WhoWeAre />
      <StoryScroll />
      <MissionVision />
      <ValuesList />
      <ImpactMetrics />
      <Philosophy />
      <AboutCta />
    </div>
  );
}

export default AboutUs;
